import { render } from "./login_tooltip.vue?vue&type=template&id=18adbdb8"
import script from "./login_tooltip.vue?vue&type=script&lang=js"
export * from "./login_tooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__